import React, { useEffect, useState } from "react";
 import MetaTags from "react-meta-tags";
import {
    Container,
    Row,
} from "reactstrap";
import PropertyForm from "../PropertyForm"
 
const AddProperty = (props) => {
  const id=props.match.params.id
 
    return (
        <>
            <div className='page-content'>
                <MetaTags>
                    <title>Property</title>
                </MetaTags>
                <Container fluid>
                    <Row className="mx-4">
                    <h4>Add New Property</h4>
                        <p>Follow the following steps and add the required info. to add compound</p>
                    </Row>
                  <PropertyForm  fromParams={true} id={id}  history={props.history}/>
                   
                </Container>
            </div>
        </>
    )
}

export default AddProperty